import * as React from 'react'
import PropTypes from 'prop-types'
import UserContext from 'context/user-context'
import AuthContext from 'context/auth-context'
import AccessManagementAppContext from 'context/access-management-app-context'
import FilterContext from 'context/filters-context'
import { AhoyProvider } from 'context/ahoy-context'
import { ErrorContextProvider } from 'contexts/ErrorContext'

function getInitialCurrentApp() {
  // Check for new currentApp key first
  const currentApp = localStorage.getItem('currentApp')
  if (currentApp) {
    return currentApp
  }

  // Migrate legacy sodApp key
  const legacySodApp = localStorage.getItem('sodApp')
  if (legacySodApp === 'true' || legacySodApp === true) {
    localStorage.setItem('currentApp', 'sod')
    localStorage.removeItem('sodApp')
    return 'sod'
  }

  return null
}

function AppProviders({ currentUser, children, token }) {
  const initialApp = getInitialCurrentApp()
  const [currentApp, setCurrentAppState] = React.useState(initialApp)

  const setCurrentApp = React.useCallback((app) => {
    setCurrentAppState(app)
    if (app) {
      localStorage.setItem('currentApp', app)
    } else {
      localStorage.removeItem('currentApp')
    }
  }, [])

  // Backward-compatible sodApp interface for components that still use it
  const sodApp = currentApp === 'sod' ? 'true' : null
  const setSodApp = React.useCallback((value) => {
    if (value === true || value === 'true') {
      setCurrentApp('sod')
    } else {
      setCurrentApp(null)
    }
  }, [setCurrentApp])

  const [filters, setFilters] = React.useState({})

  return (
    <ErrorContextProvider>
      <AuthContext.Provider value={token}>
        <UserContext.Provider value={currentUser}>
          <AccessManagementAppContext.Provider value={{ sodApp, setSodApp, currentApp, setCurrentApp }}>
            <FilterContext.Provider value={{ filters, setFilters }}>
              <AhoyProvider>{children}</AhoyProvider>
            </FilterContext.Provider>
          </AccessManagementAppContext.Provider>
        </UserContext.Provider>
      </AuthContext.Provider>
    </ErrorContextProvider>
  )
}

AppProviders.propTypes = {
  currentUser: PropTypes.object.isRequired,
  children: PropTypes.node.isRequired,
  token: PropTypes.string
}

export default AppProviders
